import * as React from 'react';
import { connect } from 'react-redux';
import '../css/SuperUserPageView.css';
import { TooltipCont } from '../../../infrastructure/tooltips';
import { getScrollbarWidth } from '../../../lib/helpers';
import {IFillerImage} from '../../../infrastructure/interfaces'
import HeaderBar from '../../HeaderBar/HeaderBar';
import DeleteConfirmModal from '../../Modals/DeleteConfirmModal';
import { contentImagesRelativePath } from '../../../constants';
import {getFillerImages, createFillerImage, editFillerImage, deleteFillerImage} from "../../../actions/actions";
import CreateEditFillerImageModal from "../../Modals/CreateEditFillerImageModal/CreateEditFillerImageModal"

export interface IManageFillerImagesProps {
    fillerImages?: IFillerImage[];
    editFillerImage(fillerImage: IFillerImage, formData?: FormData): void;
    createFillerImage(iconName: string, formData?: FormData): void;
    deleteFillerImage(icon: IFillerImage): void;
    getFillerImages(): void;
}

export interface IManageFillerImagesState {
    showEditModal: boolean;
    showDeleteFillerImageModal: boolean;
    selectedFillerImage?: IFillerImage;
}

const mapStateToProps = (state: any) => {
    return {
        fillerImages: state.fillerImageList,
    };
};

const mapDispatchToProps = (dispatch: any): any => {
    return {
        getFillerImages: () => {
            dispatch(getFillerImages());
        },
        editFillerImage: (fillerImage: IFillerImage, formData?: FormData) => {
            dispatch(editFillerImage(fillerImage, formData));
        },
        createFillerImage: (iconName: string, formData: FormData) => {
            dispatch(createFillerImage(iconName, formData));
        },
        deleteFillerImage: (crop: IFillerImage) => {
            dispatch(deleteFillerImage(crop));
        },
    };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ManageFillerImagesTable extends React.Component<IManageFillerImagesProps, IManageFillerImagesState> {
    tableRow: HTMLElement;
    componentDidMount() {
        this.props.getFillerImages();
    }

    constructor(props: IManageFillerImagesProps) {
        super(props);
        this.state = {
            showEditModal: false,
            showDeleteFillerImageModal: false,
        };
    }

    onEditFillerImage = (fillerImage: IFillerImage) => {

        this.setState({
            showEditModal: true,
            showDeleteFillerImageModal: false,
            selectedFillerImage: fillerImage,
        });
    }

    onDeleteFillerImageRequest(fillerImage: IFillerImage) {
        if(fillerImage.id) {
            this.setState({
                showEditModal: false,
                showDeleteFillerImageModal: true,
                selectedFillerImage: fillerImage,
            });
        }
    }

    onCreateFillerImage() {
        this.setState({
            showEditModal: true,
            showDeleteFillerImageModal: false,
            selectedFillerImage: undefined,
        });
    }

    deleteFillerImage(fillerImage: IFillerImage) {
        this.props.deleteFillerImage(fillerImage);
    }

    closeModals() {

        this.setState({
            showEditModal: false,
            showDeleteFillerImageModal: false,
            selectedFillerImage: undefined,
        });
    }

    render() {

        const {
            fillerImages,
        } = this.props;
        const nonNullFillerImages = fillerImages ? fillerImages : [];

        return (
            <div className="root-container">
                <HeaderBar />
                <div className="inner-su-container">
                    <div className="manage-items-row-offsetRight">

                        <div className="in-row-text-container">
                            Manage Filler Images
                        </div>

                        <div className="in-row-button-container">
                            <button
                                className="btn primary-green large"
                                onClick={() => {this.onCreateFillerImage();}}
                                title={TooltipCont.CREATE_COVER_PHOTO}
                            >
                                Upload Filler Image
                            </button>
                        </div>
                    </div>
                    <table className="table-scrollableSU documents-table">
                        <thead style={{ paddingRight: getScrollbarWidth() }}>
                        <tr>
                            <th>Name</th>
                            <th>Image</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody className="document-table-body">
                        {nonNullFillerImages.map((s: IFillerImage) =>
                            <tr key={s.id} ref={tr => this.tableRow = tr!}>
                                <td>
                                    {s.name}
                                </td>
                                <td>
                                    <img className="inlineImagesTableImage" src={contentImagesRelativePath + s.src} />
                                </td>
                                <td>
                                    <div className="button-wrapper">
                                        <button
                                            className="btn primary-blue"
                                            onClick={() => {this.onEditFillerImage(s)}}
                                            title={TooltipCont.EDIT}
                                            disabled={false}
                                        >
                                            Edit
                                        </button>
                                        <button
                                            className="btn primary-red"
                                            onClick={() => {this.onDeleteFillerImageRequest(s)}}
                                            title={TooltipCont.DELETE}
                                            disabled={false}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </td>
                            </tr>)}
                        </tbody>
                    </table>

                    <CreateEditFillerImageModal
                        show={this.state.showEditModal}
                        fillerImage={this.state.selectedFillerImage}
                        onClose={() => this.closeModals()}
                        editFillerImage={(fillerImage: IFillerImage, formData?: FormData) => {
                            this.props.editFillerImage(fillerImage, formData)
                            this.closeModals();
                        }
                        }
                        createFillerImage={(iconName: string, formData?: FormData) => {
                            this.props.createFillerImage(iconName, formData)
                            this.closeModals();
                        }
                        }
                    />

                    <DeleteConfirmModal
                        show={this.state.showDeleteFillerImageModal}
                        onClose={() => this.closeModals()}
                        onSave={() => {
                            if(this.state.selectedFillerImage && this.state.selectedFillerImage.id) {
                                this.deleteFillerImage(this.state.selectedFillerImage);
                            }
                            this.closeModals();
                        }}
                        title={(this.state.selectedFillerImage)
                            ? 'Delete Filler Image "' + this.state.selectedFillerImage.name + '"?'
                            : 'Error. Please go back.'}
                    />
                </div>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManageFillerImages.tsx